import { render, staticRenderFns } from "./txtStylePicker.vue?vue&type=template&id=243d286a&scoped=true&"
import script from "./txtStylePicker.vue?vue&type=script&lang=js&"
export * from "./txtStylePicker.vue?vue&type=script&lang=js&"
import style0 from "./txtStylePicker.vue?vue&type=style&index=0&id=243d286a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d286a",
  null
  
)

export default component.exports